export default __webpack_public_path__ + "media/zurb/img/playground/measurement-icon-d03f8730576fc37213ca3a2a28adbf8b.png";